const defaultLangcode = 'default';

export default defaultLangcode;
